const text = `[[topSection]]La tua privacy è molto importante per [[publisherName]]. Vogliamo pertanto informarvi di quanto segue:

Archiviamo informazioni sul tuo dispositivo per far funzionare questo sito Web. È possibile accedere al dispositivo anche da [[thirdPartiesUrl]] per l'archiviazione di informazioni simili.

I dati personali, come il tuo indirizzo IP e ID utente univoci, possono essere utilizzati da noi e [[thirdPartiesUrl]] per i seguenti scopi, per i quali [[thirdPartiesUrl]] può richiedere il tuo consenso:
[[purposes]]

Finalità per le quali [[thirdPartiesUrl]] rivendica un interesse legittimo senza il diritto di opporsi:
[[legitimateInterest]]

E funzionalità per le quali [[thirdPartiesUrl]] richiede esplicitamente la tua partecipazione:
[[features]]

Forniamo questa interfaccia per darti il controllo delle tue impostazioni sulla privacy. È possibile modificare le impostazioni sulla privacy in qualsiasi momento durante la visita del nostro sito Web. Per aprire questa finestra di dialogo, vai al pulsante Privacy sullo schermo.

Oltre a chiedere il tuo consenso, [[thirdPartiesUrl]] può rivendicare [[legitimateInterestUrl]] come base legale per l'elaborazione dei dati personali. Nella maggior parte dei casi, hai il diritto di opporti a questo. Un segnale per inoltrare la tua opposizione a una "terza parte" è gestito da questo gestore della privacy.

La sospensione del consenso può portare alla visualizzazione di più annunci e annunci non adatti ai tuoi interessi.

Qualsiasi consenso, obiezione o opt-in forniti, ha una portata limitata a questo sito Web.
[[bottomSection]]
`;
export default text;